<template>
  <BasicLayout>
    <template #wrapper>
      <el-card class="box-card">
        <div slot="header" class="clearfix">
          <span>矿工配置</span>
          <CommonExport :import-p="'config:mining:import'" :export-p="'config:mining:export'" :import-method="importMining" :export-method="exportMining" :get-table="getTables" />
          <syncVersion :in-method="uploadMiningJson" :params="params" />

          <clear-cache-apply />
        </div>

        <el-card>
          <div slot="header" class="clearfix">
            <span>基础配置</span>
          </div>
          <el-form :model="commonCfg" class="demo-form-inline">
            <el-form-item label="收币效果">
              <el-input v-model.number="commonCfg.num" style="width: 250px;" placeholder="累计多少个币播放一次收币效果" />
              <span class="tips"><i class="el-icon-warning-outline" /> 累计多少个币播放一次收币效果</span>
            </el-form-item>
            <el-form-item label="玩家帮助次数">
              <el-input v-model.number="commonCfg.maxHelpTime" style="width: 250px;" placeholder="玩家帮助次数" />
            </el-form-item>
            <el-form-item label="最大帮助人数">
              <el-input v-model.number="commonCfg.helpNum" style="width: 250px;" placeholder="最大帮助人数" />
            </el-form-item>
            <el-form-item label="帮助时长(分)">
              <el-input v-model.number="commonCfg.helpTime" style="width: 250px;" placeholder="帮助时长" />
            </el-form-item>
            <el-form-item label="玩家帮助奖励">
              <reward :limit-type="limitType" :value="commonCfg.prize" />
            </el-form-item>
          </el-form>
          <el-button type="primary" @click="commonOnSubmit">保存</el-button>
        </el-card>

        <el-table size="mini" style="margin-top: 20px;" :data="formData" border stripe>
          <el-table-column prop="id" label="关卡ID" width="80">
            <template v-slot:default="scope">
              <el-input v-model.number="scope.row.id" size="mini" />
            </template>
          </el-table-column>
          <el-table-column prop="moneyIncome" label="钱收入(/h)">
            <template v-slot:default="scope">
              <el-input v-model.number="scope.row.moneyIncome" size="mini" />
            </template>
          </el-table-column>
          <el-table-column prop="diamondCapacity" label="钱最大容量">
            <template v-slot:default="scope">
              <el-input v-model.number="scope.row.moneyCapacity" size="mini" />
            </template>
          </el-table-column>
          <el-table-column prop="coinIncome" label="野兽币收入(/h)">
            <template v-slot:default="scope">
              <el-input v-model.number="scope.row.coinIncome" size="mini" />
            </template>
          </el-table-column>
          <el-table-column prop="coinCapacity" label="野兽币最大容量">
            <template v-slot:default="scope">
              <el-input v-model.number="scope.row.coinCapacity" size="mini" />
            </template>
          </el-table-column>
          <el-table-column prop="diamondIncome" label="钻石保底次数">
            <template v-slot:default="scope">
              <el-input v-model.number="scope.row.diamondFloor" size="mini" />
            </template>
          </el-table-column>
          <el-table-column prop="diamondIncome" label="钻石产出概率(%)">
            <template v-slot:default="scope">
              <el-input v-model.number="scope.row.diamondPro" size="mini" />
            </template>
          </el-table-column>
          <el-table-column prop="diamondCapacity" label="钻石产出数量">
            <template v-slot:default="scope">
              <el-input v-model.number="scope.row.diamondNum[0]" size="mini" />
              -
              <el-input v-model.number="scope.row.diamondNum[1]" size="mini" />
            </template>
          </el-table-column>
          <el-table-column prop="diamondCapacity" label="钻石产出数量限制">
            <template v-slot:default="scope">
              <el-input v-model.number="scope.row.diamondLimit" size="mini" />
            </template>
          </el-table-column>
          <el-table-column prop="diamondCapacity" label="钻石产出时间间隔(/h)">
            <template v-slot:default="scope">
              <el-input v-model.number="scope.row.diamondInterval" size="mini" />
            </template>
          </el-table-column>
          <el-table-column prop="workerNum" label="最大工人数量">
            <template v-slot:default="scope">
              <el-input v-model.number="scope.row.workerNum" size="mini" />
            </template>
          </el-table-column>
          <el-table-column prop="needTime" label="解锁时间(秒)">
            <template v-slot:default="scope">
              <el-input v-model.number="scope.row.needTime" size="mini" />
            </template>
          </el-table-column>
          <el-table-column prop="helpMoneyIncome" label="帮助钱收入(/h)">
            <template v-slot:default="scope">
              <el-input v-model.number="scope.row.helpMoneyIncome" size="mini" />
            </template>
          </el-table-column>
          <el-table-column prop="helpCoinIncome" label="帮助野兽币收入(/h)">
            <template v-slot:default="scope">
              <el-input v-model.number="scope.row.helpCoinIncome" size="mini" />
            </template>
          </el-table-column>
          <el-table-column prop="num" label="矿工数据" width="120px">
            <template v-slot:default="scope">
              <el-button type="text" @click="drawer[scope.$index].visible = true">配置</el-button>
              <el-drawer title="配置" :visible.sync="drawer[scope.$index].visible" :with-header="false" size="650px">
                <el-form :inline="true">
                  <el-row v-for="(item, index) in scope.row.worker" :key="index">
                    <el-form-item :label="'价格'+ item.id">
                      <el-input v-model.number="item.price" style="width: 150px;" placeholder="价格" />
                    </el-form-item>
                    <el-form-item label="建造时间">
                      <el-input v-model.number="item.reduce" style="width: 150px;" placeholder="减少时间" />
                    </el-form-item>
                    <el-form-item>
                      <el-button v-permisaction="['config:mining:del']" type="danger" @click="delElement(scope.$index, index)">删除</el-button>
                    </el-form-item>
                  </el-row>
                  <el-button v-if="scope.row.worker.length < 5" v-permisaction="['config:mining:add']" style="margin-top: 5px" type="primary" @click="addElement(scope.$index)">+</el-button>
                </el-form>
              </el-drawer>
            </template>
          </el-table-column>
          <el-table-column prop="num" label="加速数据" width="120px">
            <template v-slot:default="scope">
              <el-button type="text" @click="handleReduceTime(scope.row.reduceTime)">配置</el-button>
            </template>
          </el-table-column>
          <el-table-column prop="num" label="奖励" width="120px">
            <template v-slot:default="scope">
              <Reward :value="scope.row.reward" />
            </template>
          </el-table-column>
          <el-table-column label="操作" width="120px">
            <template v-slot:default="scope">
              <el-button v-permisaction="['config:mining::del']" type="danger" @click="del(scope.row.id)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div style="margin-top: 10px;text-align: center">
          <el-button v-permisaction="['config:mining::add']" type="primary" @click="add()">+</el-button>
          <el-button v-permisaction="['config:mining::add']" type="primary" @click="onSubmit()">保存</el-button>
        </div>
        <pagination v-show="total>0" background :page.sync="queryParams.pageIndex" :limit.sync="queryParams.pageSize" :total="total" @pagination="getTables" />
      </el-card>
      <el-drawer title="配置" :visible.sync="reduceTimeDrawer" :with-header="false" size="1050px">
        <el-table size="mini" style="margin-top: 20px;" :data="reduceTime" border stripe>
          <el-table-column prop="id" label="价格">
            <Price :limit-type="[3,4]" />
          </el-table-column>
          <el-table-column prop="moneyIncome" label="减少时间(秒)">
            <template v-slot:default="scope">
              <el-input v-model.number="scope.row.reduce" size="mini" />
            </template>
          </el-table-column>
          <el-table-column prop="moneyIncome" label="操作">
            <template v-slot:default="{scope,$index}">
              <el-button v-permisaction="['config:mining:del']" type="danger" @click="delReduceTime($index)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-button style="margin-top: 5px" type="primary" @click="addReduceTime">+</el-button>
      </el-drawer>
    </template>
  </BasicLayout>
</template>

<script>
import { getCommonCfg, updateCommonCfg } from '@/api/config/common-cfg'
import ClearCacheApply from '@/components/clear_cache_apply/index.vue'
import SyncVersion from '@/components/SyncVersion/index.vue'
import {
  delMining,
  exportMining,
  getMiningList,
  importMining,
  updateMiningCfg,
  uploadMiningJson
} from '@/api/config/mining-cfg'
import Reward from '@/components/Reward/index.vue'
import CommonExport from '@/components/CommonExport/index.vue'
import Price from '@/components/Price'
export default {
  name: 'MiningConfig',
  components: { Price, CommonExport, Reward, SyncVersion, ClearCacheApply },
  data() {
    return {
      name: 'MiningConfig2',
      params: { name: 'MiningConfig2' },
      loading: false,
      total: 0,
      limitType: [14, 15, 65, 22],
      drawer: [{ visible: false }],
      queryParams: {
        pageIndex: 1,
        pageSize: 10
      },
      commonCfg: {
        prize: [],
        num: 0,
        maxHelpTime: 0,
        helpNum: 3,
        helpTime: 30
      },
      formData: [{
        id: 0,
        worker: [],
        coinIncome: 0,
        coinCapacity: 5,
        moneyIncome: 0,
        moneyCapacity: 0,
        workerNum: 0,
        needTime: 0,
        helpMoneyIncome: 0,
        helpCoinIncome: 0,
        diamondFloor: 0,
        diamondPro: 0,
        diamondNum: [1, 5],
        diamondLimit: 0,
        diamondInterval: 0,
        reduceTime: []
      }],
      reduceTimeDrawer: false,
      reduceTime: []
    }
  },
  created() {
    this.getTables()
  },
  methods: {
    importMining,
    exportMining,
    uploadMiningJson,
    commonOnSubmit() {
      const data = JSON.stringify(this.commonCfg)
      updateCommonCfg({ name: this.name, data: data }).then(res => {
        if (res.code === 200) {
          this.msgSuccess(res.msg)
          this.getTables()
        } else {
          this.msgError(res.msg)
        }
      })
    },
    onSubmit() {
      for (const i in this.formData) {
        const _data = this.formData[i]
        if (_data.id <= 0) {
          this.msgError('关卡ID不能是0')
          return
        }
      }
      updateMiningCfg({ data: JSON.stringify(this.formData) }).then(res => {
        if (res.code === 200) {
          this.msgSuccess(res.msg)
          this.getTables()
        } else {
          this.msgError(res.msg)
        }
      })
    },
    getTables() {
      this.loading = true
      getMiningList(this.queryParams).then(res => {
        this.loading = false
        if (res.code === 200) {
          this.formData = res.data.list
          if (this.formData.length) {
            this.formData.forEach((res, index) => {
              if (!res.reward) {
                this.formData[index].reward = []
              }
              this.drawer.push({ visible: false })
            })
          }
          this.total = res.data.count
        } else {
          this.msgError(res.msg)
        }
      })
      getCommonCfg({ name: this.name }).then(res => {
        if (!res.data.prize) {
          res.data.prize = []
        }
        this.commonCfg = res.data
      })
    },
    add() {
      this.formData.push({
        id: 0,
        worker: [],
        needTime: 0,
        helpMoneyIncome: 0,
        helpCoinIncome: 0,
        moneyIncome: 5,
        moneyCapacity: 0,
        coinIncome: 0,
        coinCapacity: 0,
        diamondFloor: 0,
        diamondPro: 0,
        diamondNum: [1, 5],
        diamondLimit: 0,
        diamondInterval: 0
      })
      this.drawer.push({ visible: false })
    },
    addElement(index) {
      const num = this.formData[index].worker.length + 1
      this.formData[index].worker.push({ id: num, price: 0, reduce: 0 })
    },
    delElement(index, i) {
      this.formData[index].worker = this.formData[index].worker.filter((item, key) => {
        return i !== key
      })
      let num = 0
      this.formData[index].worker.forEach((item, idx) => {
        num++
        if (num === 1) {
          this.formData[index].worker[idx].price = 0
        }
        this.formData[index].worker[idx].id = num
      })
    },
    del(id) {
      this.$confirm('确认要删除吗?', '警告', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        delMining({ id: id }).then(res => {
          if (res.code === 200) {
            this.msgSuccess(res.msg)
            this.getTables()
          } else {
            this.msgError(res.msg)
          }
        })
      })
    },
    delReduceTime(index) {
      this.reduceTime.splice(index, 1)
    },
    addReduceTime() {
      this.reduceTime.push({ 'bet': 1, 'mtype': 3 })
    },
    handleReduceTime(data) {
      this.reduceTimeDrawer = true
      this.reduceTime = data
    }
  }
}
</script>

<style scoped>
.tips{
  margin-left: 10px;
}
</style>
